import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { sortBy } from "lodash";

export type FiltersToShowType = {
  age: boolean;
  dow: boolean;
  time: boolean;
  date: boolean;
  price: boolean;
  classSize: boolean;
  format: boolean;
  classType: boolean;
  language: boolean;
  curriculum: boolean;
  standards: boolean;
};

export const filtersToShowDefault = () => ({
  age: true,
  dow: true,
  time: true,
  date: true,
  price: true,
  classSize: true,
  format: true,
  classType: true,
  language: true,
  curriculum: true,
  standards: true,
});

export function getFiltersToShow(
  preSetFilters: SearchFiltersType,
  childrenAges: number[] = [],
) {
  const filters = filtersToShowDefault();

  const DBFilters = Object.keys(preSetFilters).filter(
    // @ts-ignore
    el => preSetFilters[el] != null && preSetFilters[el] != "",
  );

  const filterAge = preSetFilters.age ?? [];

  filters.age =
    childrenAges.length > 0
      ? sortBy(childrenAges).join(",") === filterAge
      : !DBFilters.includes("age");

  filters.dow = !DBFilters.includes("dow");
  filters.time =
    !DBFilters.includes("startAfterTime") || !DBFilters.includes("endByTime");
  filters.date =
    !DBFilters.includes("startAfter") || !DBFilters.includes("endBy");
  filters.price =
    !DBFilters.includes("pricePerMeetingMax") ||
    !DBFilters.includes("pricePerMeetingMin");
  filters.classSize =
    !DBFilters.includes("capacityMax") || !DBFilters.includes("capacityMin");
  filters.format = !DBFilters.includes("delivery");
  filters.classType = !DBFilters.includes("format");
  filters.language = !DBFilters.includes("languageOfInstruction");

  return filters;
}
